<template>
  <div class="home">
    <h2>Testers Phones</h2>

    <b-button @click="raisePopup({ target: $event.target })" variant="primary">
      Add new
    </b-button>

    <!-- Info modal -->
    <b-modal
      id="testersPhonesModal"
      v-bind:title="this.isEdit ? 'Edit testers phones' : 'New testers phones'"
      ref="testersPhonesModal"
      @ok="testersPhonesFormSubmit"
    >
      <b-form>
        <b-form-group id="newTestersPhonesInputGroup1">
          <b-form-input
            v-model="form.whitelabelId"
            id="newTestersPhonesInput1"
            type="number"
            placeholder="Enter Whitelabel ID"
            @change="onWlChange()"
          />
        </b-form-group>
        <hr />
        <b-form-group label="Phones">
          <ul>
            <li v-for="(phone, index) in form.phones" class="no-bullet">
              <b-form-group :id="`newTestersPhonesInputGroup2${index}`">
                <b-row>
                  <b-col sm="10"
                    ><b-form-input
                      :id="`newTestersPhonesInput2${index}`"
                      v-model="form.phones[index]"
                      :placeholder="`phone ${index + 1}`"
                  /></b-col>
                  <b-col sm="1"
                    ><b-button
                      size="sm"
                      variant="danger"
                      class="m-1 ml-3"
                      @click="removeTesterPhone(index)"
                    >
                      X
                    </b-button></b-col
                  ></b-row
                >
              </b-form-group>
            </li>
          </ul>
          <b-button @click="addPhone()">Add phone</b-button>
        </b-form-group>
        <hr />
        <b-form-group id="newTestersPhonesGroup2">
          <b-form-checkbox v-model="form.isActive"
            >Is record active?</b-form-checkbox
          >
        </b-form-group>
        <div v-if="showModalError" class="error">Fill all fields</div>
      </b-form>
    </b-modal>

    <b-container fluid>
      <!-- Main table element -->
      <b-table
        show-empty
        small
        hover
        stacked="md"
        :items="items"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        @filtered="onFiltered"
        ref="testersPhonesTable"
        class="testersPhonesTable"
      >
        <template v-slot:cell(actions)="row">
          <b-button
            size="sm"
            class="m-1"
            @click="row.toggleDetails"
            variant="info"
          >
            …
          </b-button>
          <b-button
            size="sm"
            class="m-1"
            variant="warning"
            @click="
              raisePopup({
                target: $event.target,
                isEdit: true,
                testersPhones: row.item
              })
            "
          >
            ✎
          </b-button>
          <b-button
            size="sm"
            variant="danger"
            class="m-1 ml-3"
            @click="
              removeTestersPhones({
                target: $event.target,
                testersPhones: row.item
              })
            "
          >
            X
          </b-button>
        </template>
        <template v-slot:cell(whitelabelId)="row">
          {{ `${row.value} (${row.item['whitelabel.name']})` }}
        </template>
        <template v-slot:cell(isActive)="row">
          {{ row.value ? 'Yes' : 'No' }}
        </template>

        <template v-slot:row-details="row">
          <b-card>
            <ul>
              <li v-for="(value, key) in row.item" :key="key">
                {{ key }}: {{ value }}
              </li>
            </ul>
          </b-card>
        </template>
      </b-table>
    </b-container>
  </div>
</template>

<script>
/* eslint-disable no-magic-numbers */

const originalForm = {
  id: null,
  whitelabelId: null,
  phones: null,
  isActive: false
};

export default {
  data() {
    return {
      currentPage: 1,
      perPage: 20,
      sortBy: null,
      sortDesc: false,
      filter: null,
      form: {
        ...originalForm
      },
      isEdit: false,
      showModalError: false
    };
  },
  computed: {
    fields() {
      return [
        {
          key: 'id',
          label: 'id',
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'whitelabelId',
          label: 'whitelabel',
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'phones',
          label: 'Phones',
          sortable: false,
          class: 'text-center'
        },
        {
          key: 'isActive',
          label: 'Record is active',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'createdAt',
          label: 'Created',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'updatedAt',
          label: 'Updated',
          sortable: true,
          class: 'text-center'
        },
        { key: 'actions', label: 'Actions' }
      ];
    },
    totalRows() {
      return this.$store.state.testersPhones.count;
    }
  },
  methods: {
    raisePopup({ target, isEdit = false, testersPhones = null }) {
      this.isEdit = isEdit;
      if (testersPhones && isEdit) {
        this.form = Object.keys(originalForm).reduce(
          (acc, current) => ({
            ...acc,
            [current]: testersPhones[current]
          }),
          {}
        );
      } else {
        this.testersPhonesFormReset();
      }
      this.$root.$emit('bv::show::modal', 'testersPhonesModal', target);
    },
    removeTestersPhones({ testersPhones = null }) {
      if (!testersPhones) {
        return;
      }
      const promise = this.$store.dispatch(
        'removeTestersPhones',
        testersPhones.id
      );

      // Must return a promise that resolves to an array of items
      return promise.then(() => {
        this.$refs.testersPhonesTable.refresh();
      });
    },
    removeTesterPhone(index) {
      this.form.phones.splice(index, 1);
    },
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.currentPage = 1;
    },
    items(ctx) {
      const promise = this.$store.dispatch('getTestersPhones', ctx);

      // Must return a promise that resolves to an array of items
      return promise.then(() => {
        const items = this.$store.state.testersPhones.rows.map(phones => {
          if (phones.isActive) {
            phones._rowVariant = 'success';
          }
          return phones;
        });
        // Must return an array of items or an empty array if an error occurred
        return items || [];
      });
    },
    testersPhonesFormReset() {
      this.form = { ...originalForm };
    },
    async testersPhonesFormSubmit(event) {
      event.preventDefault();

      const isValid =
        this.form.whitelabelId &&
        this.form.phones &&
        this.form.phones.length &&
        this.form.phones.length ===
          this.form.phones.filter(phone => !!phone).length;

      if (!isValid) {
        this.showModalError = true;
        return;
      }

      this.showModalError = false;
      if (!this.isEdit) {
        await this.$store.dispatch('addTestersPhones', {
          testersPhones: this.form,
          event
        });
      } else {
        await this.$store.dispatch('editTestersPhones', {
          testersPhones: this.form,
          event
        });
      }

      this.testersPhonesFormReset();
      this.$refs.testersPhonesTable.refresh();
      this.$refs.testersPhonesModal.isClosing = false;
      this.$refs.testersPhonesModal.hide();
    },
    addPhone() {
      if (!this.form.phones) {
        this.form.phones = [];
      }
      this.form.phones.push('');
    },
    onWlChange() {
      const record = this.$store.state.testersPhones.rows.find(
        item => item.whitelabelId.toString() === this.form.whitelabelId
      );

      if (record) {
        this.form.id = record.id;
        this.form.phones = record.phones;
        this.form.isActive = record.isActive;
      } else {
        this.form.id = originalForm.id;
        this.form.phones = originalForm.phones;
        this.form.isActive = originalForm.isActive;
      }
    }
  }
};
</script>
<style scoped type="text/scss">
.testersPhonesTable {
  font-size: 0.8rem;
}

li.no-bullet {
  list-style: none;
}

td[data-label='Actions'] {
  white-space: nowrap;
}

.error {
  color: red;
}
</style>
